import styled from 'styled-components'

export const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 280px;
  min-width: 0;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    min-height: auto;
    min-width: 0 !important;
    overflow: visible !important;
  }
`

export const ChartContainer = styled.div<{ $height?: number }>`
  width: 100%;
  height: ${({ $height }) => $height || 250}px;

  @media print {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: ${({ $height }) => $height || 250}px !important;
    overflow: visible !important;
    position: relative !important;

    /* Ensure canvas respects container bounds */
    canvas {
      max-width: 100% !important;
      position: relative !important;
      left: 0 !important;
    }
  }
`

export const StatsLine = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
  margin-top: 8px;
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`
